var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-lone-blocks */
import HLS from 'hls.js';
import * as React from 'react';
import PlaybackManager from './PlaybackManager';
import { PlayerState } from './types';
import 'rc-slider/assets/index.css';
import { VOLUME_0_SVG, VOLUME_2_SVG, VOLUME_1_SVG, PLAYER_CLOSE_SVG, PLAY_RUBY_SVG, PAUSE_RUBY_SVG } from "../assets";
import * as moment from 'moment';
import Slider from 'rc-slider';
import { PlayerContextConsumer } from "../context";
import { UserContextConsumer } from '../context/user';
import { BPMSoundsGeneric } from '../generic';
import { SoundManager } from '../manager';
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            paused: PlaybackManager.getInstance().getPlayingState() == PlayerState.Paused,
            muted: false,
            repeat: PlaybackManager.getInstance().autorepeat,
            loading: false,
            visible: false,
            volumePopupOpenDelayedClose: false,
            volume: 0,
            popupVisibleState: 'hidden'
        };
        PlaybackManager.getInstance()._internalPlayer = _this;
        _this.bindVideoElem = _this.bindVideoElem.bind(_this);
        _this.handleAudioEvent = _this.handleAudioEvent.bind(_this);
        return _this;
    }
    Player.hlsSupported = function () {
        return HLS.isSupported();
    };
    Object.defineProperty(Player.prototype, "isVisible", {
        get: function () {
            return this.state.visible;
        },
        enumerable: false,
        configurable: true
    });
    Player.getStartSilence = function (silence_info) {
        if (!silence_info) {
            return 0;
        }
        if (silence_info == '') {
            return 0;
        }
        try {
            var first = silence_info.split('|')[0];
            var start = first.split('s=')[1].split(';')[0];
            if (parseFloat(start) == 0.0) {
                var end = first.split('e=')[1];
                if (!Number.isNaN(parseFloat(end))) {
                    return parseFloat(end);
                }
            }
        }
        catch (error) {
        }
        return 0;
    };
    Player.prototype.setStreamedDuration = function (apiType) {
        var _a;
        var sound = (_a = PlaybackManager.getInstance().getTrack()) === null || _a === void 0 ? void 0 : _a.sound;
        var progress = PlaybackManager.getInstance().getProgress();
        if (progress) {
            SoundManager.getInstance().setStreamDuration(sound.id, progress.toFixed(2));
            PlaybackManager.getInstance().getTrack() && BPMSoundsGeneric.get().setStreamedDuration &&
                BPMSoundsGeneric.get().setStreamedDuration(sound, progress, apiType);
        }
    };
    Player.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('beforeunload', function (e) {
            if ('sendBeacon' in navigator) {
                _this.setStreamedDuration('beacon');
            }
        });
        document.addEventListener('click', function (e) {
            function hasSomeParentTheClass(element, classname) {
                if (!element) {
                    return true; // element is not in dom anymore
                }
                if (!element.tagName) {
                    if (element.parentNode) {
                        return hasSomeParentTheClass(element.parentNode, classname);
                    }
                    else {
                        return true;
                    }
                }
                if (element.tagName.toLowerCase() == 'body') {
                    return false;
                }
                if (!element.classList)
                    return hasSomeParentTheClass(element.parentNode, classname);
                if (element.className && typeof element.className == 'string' && element.className.split(' ').indexOf(classname) >= 0)
                    return true;
                return hasSomeParentTheClass(element.parentNode, classname);
            }
            if (hasSomeParentTheClass((e.target || e.currentTarget), 'popup-click-handler')) {
                return;
            }
        });
    };
    Player.prototype.initHLSIfRequired = function () {
        var _this = this;
        if (Player.hlsSupported()) {
            if (this.hls_player) {
                this.hls_player.destroy();
                this.hls_player = undefined;
            }
            this.hls_player = new HLS({
                defaultAudioCodec: 'mp4a.40.5',
                xhrSetup: function (xhr, url) {
                    xhr.withCredentials = true;
                }
            });
            this.hls_player.on(HLS.Events.ERROR, function (event, data) {
                if (data.fatal) {
                    switch (data.type) {
                        case HLS.ErrorTypes.NETWORK_ERROR:
                            if (data.details == 'manifestLoadError') {
                                if (data.networkDetails) {
                                    if (data.networkDetails.status != 200) {
                                        _this.onError && _this.onError('FileNotFound', data);
                                        return;
                                    }
                                }
                            }
                            _this.onError && _this.onError('Unknown', data);
                            break;
                        case HLS.ErrorTypes.MEDIA_ERROR:
                            _this.hls_player.recoverMediaError();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
    Player.isSafari = function () {
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    };
    Player.prototype.play = function (_a) {
        var _this = this;
        var url = _a.url, onEnd = _a.onEnd, onError = _a.onError, onPlay = _a.onPlay, onProgress = _a.onProgress, onStateChange = _a.onStateChange, totalDuration = _a.totalDuration, type = _a.type, silence_info = _a.silence_info;
        var showAudioPlayer = this.props.shouldShowPlayerForAudioType(type);
        if (showAudioPlayer) {
            if (!this.state.visible) {
                this.setState({ visible: true });
                setTimeout(function () {
                    _this.setState({ popupVisibleState: 'visible' });
                }, 300);
            }
        }
        else if (this.state.visible) {
            this.setState({ visible: false });
        }
        this.silence_info = silence_info;
        this.onError = onError;
        this.onPlay = onPlay;
        this.onProgress = onProgress;
        this.onStateChange = onStateChange;
        this.onEnd = onEnd;
        this.totalDuration = totalDuration;
        this.initHLSIfRequired();
        if (this.hls_player && url.includes('.m3u8')) {
            this.hls_player.loadSource((url));
            this.videoElem && this.hls_player.attachMedia(this.videoElem);
            this.hls_player.on(HLS.Events.MEDIA_ATTACHED, function () {
                _this.videoElem && _this.videoElem.play();
            });
            var startAfterSilence = Player.getStartSilence(this.silence_info);
            if (startAfterSilence && this.videoElem && this.videoElem.currentTime < startAfterSilence) {
                this.seek(startAfterSilence);
            }
        }
        else if (this.videoElem) {
            if (this.videoElem.src != url) {
                this.videoElem.pause();
                this.videoElem.src = url;
            }
            this.videoElem.play();
        }
    };
    Player.prototype.resume = function (cb) {
        this.videoElem && this.videoElem.play();
        this.onStateChange && this.onStateChange(PlayerState.Playing);
        cb && cb();
    };
    Player.prototype.pause = function (cb) {
        this.videoElem && this.videoElem.pause();
        this.onStateChange && this.onStateChange(PlayerState.Paused);
        cb && cb();
    };
    Player.prototype.seek = function (to) {
        if (this.videoElem) {
            this.videoElem.currentTime = to;
        }
    };
    Player.prototype.setVolume = function (to) {
        if (this.videoElem) {
            this.videoElem.volume = to;
            this.setState({ volume: to });
        }
    };
    Player.prototype.getVolume = function () {
        var _a;
        return (_a = this.videoElem) === null || _a === void 0 ? void 0 : _a.volume;
    };
    Player.prototype.stop = function () {
        this.videoElem && this.videoElem.pause();
        this.setState({ visible: false });
    };
    Player.prototype.handleAudioEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var startAfterSilence;
            return __generator(this, function (_a) {
                switch (event.type) {
                    case 'play':
                        this.onStateChange && this.onStateChange(PlayerState.Buffering);
                        // No play event, we do not have the duration yet
                        break;
                    case 'playing':
                        this.onStateChange && this.onStateChange(PlayerState.Playing);
                        break;
                    case 'pause':
                        this.setStreamedDuration();
                        this.onStateChange && this.onStateChange(PlayerState.Paused);
                        break;
                    case 'durationchange':
                        break;
                    case 'timeupdate':
                        this.onProgress && this.videoElem && this.onProgress(this.videoElem.currentTime, this.videoElem.duration);
                        break;
                    case 'loadedmetadata':
                        this.onStateChange && this.onStateChange(PlayerState.Playing);
                        this.onPlay && this.videoElem && this.onPlay(this.videoElem.duration);
                        this.videoElem && this.setState({ currentDuration: this.videoElem.duration });
                        startAfterSilence = Player.getStartSilence(this.silence_info);
                        if (startAfterSilence && this.videoElem && this.videoElem.currentTime < startAfterSilence) {
                            this.seek(startAfterSilence);
                        }
                        break;
                    case 'ended':
                        this.onEnd && this.onEnd(this.playPauseButton);
                        break;
                    case 'error':
                        this.onError && this.onError('FileNotFound', undefined);
                        break;
                    case 'canplay':
                        break;
                    case 'canplaythrough':
                        break;
                }
                return [2 /*return*/];
            });
        });
    };
    Player.prototype.bindVideoElem = function (elem) {
        this.videoElem = elem;
        if (!elem) {
            return;
        }
        this.hls_player && this.hls_player.attachMedia(this.videoElem);
        this.videoElem.addEventListener('seeking', this.handleAudioEvent);
        this.videoElem.addEventListener('timeupdate', this.handleAudioEvent);
        this.videoElem.addEventListener('seeked', this.handleAudioEvent);
        this.videoElem.addEventListener('pause', this.handleAudioEvent);
        this.videoElem.addEventListener('canplay', this.handleAudioEvent);
        this.videoElem.addEventListener('canplaythrough', this.handleAudioEvent);
        this.videoElem.addEventListener('ended', this.handleAudioEvent);
        this.videoElem.addEventListener('playing', this.handleAudioEvent);
        this.videoElem.addEventListener('error', this.handleAudioEvent);
        this.videoElem.addEventListener('loadedmetadata', this.handleAudioEvent);
        this.videoElem.addEventListener('loadeddata', this.handleAudioEvent);
        this.videoElem.addEventListener('durationchange', this.handleAudioEvent);
        this.videoElem.addEventListener('play', this.handleAudioEvent);
        this.setState({ volume: this.videoElem.volume });
    };
    Player.prototype.render = function () {
        var _this = this;
        return React.createElement(PlayerContextConsumer, null, function (playbackState) {
            var video = React.createElement("audio", { ref: _this.bindVideoElem, style: { display: 'block' }, onContextMenu: function (e) {
                    e.preventDefault();
                    return false;
                }, controlsList: "nodownload", playsInline: true, controls: PlaybackManager.getInstance().isPlayingVideo(), muted: false, onVolumeChange: function (e) {
                    if (_this.state.volume != e.currentTarget.volume) {
                        _this.setState({ volume: e.currentTarget.volume });
                    }
                    else if (e.currentTarget.muted != _this.state.muted) {
                        _this.setState({ muted: e.currentTarget.muted });
                    }
                }, onPlay: function (e) {
                } });
            var media = playbackState.media;
            {
                return React.createElement(React.Fragment, null,
                    video,
                    React.createElement("div", { ref: function (ref) { return _this.audioPlayerContainer = ref; }, className: "audio-player " + (!_this.state.visible ? 'hidden' : '') },
                        media && media.sound.Label && React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "left-container" },
                                React.createElement("div", { className: "col artwork" },
                                    React.createElement("img", { className: "artwork", src: media.sound.artwork_url, alt: "", onClick: function () {
                                            _this.props.onSoundPackageClick({ id: media.sound.sound_package_id });
                                        } })),
                                React.createElement("div", { className: "col label-title" },
                                    React.createElement("div", { className: "title", "data-tip": true, "data-for": 'track-info', onClick: function () {
                                            _this.props.onSoundPackageClick({ id: media.sound.sound_package_id });
                                        } }, media.sound.name),
                                    React.createElement("div", { className: "label", onClick: function () {
                                            if (media.sound.Label) {
                                                _this.props.onRouting('/labels/' + media.sound.Label.name);
                                            }
                                        } }, media.sound.Label.name)))),
                        React.createElement("div", { className: "middle-container" },
                            React.createElement("div", { className: "col controls" },
                                React.createElement("img", { ref: function (ref) { return _this.playPauseButton = ref; }, className: "img play my-auto grow", onClick: function () {
                                        if (PlaybackManager.getInstance().getPlayingState() < PlayerState.Loading) {
                                            PlaybackManager.getInstance().play();
                                        }
                                        else {
                                            PlaybackManager.getInstance().pause();
                                        }
                                    }, src: PlaybackManager.getInstance().getPlayingState() < PlayerState.Loading ? PLAY_RUBY_SVG : PAUSE_RUBY_SVG })),
                            React.createElement(PlayerProgress, { className: 'col bpmprogress' }),
                            React.createElement("div", { className: "col settings" },
                                React.createElement("div", { className: "volume my-auto", onMouseEnter: function () {
                                        _this.setState({ volumePopupOpenDelayedClose: true });
                                        _this.volumePoupCoseTimer && clearTimeout(_this.volumePoupCoseTimer);
                                    }, onMouseLeave: function () {
                                        _this.volumePoupCoseTimer = setTimeout(function () {
                                            _this.setState({ volumePopupOpenDelayedClose: false });
                                        }, 400);
                                    } },
                                    React.createElement("div", { className: "volume-control my-auto", style: { visibility: _this.state.volumePopupOpenDelayedClose ? _this.state.popupVisibleState : 'hidden', right: "55px" } },
                                        React.createElement(Slider, { vertical: true, min: 0, max: 1, step: .02, value: _this.state.muted ? 0 : _this.state.volume, onChange: function (e) {
                                                if (_this.videoElem) {
                                                    _this.setState({ volume: e, muted: false });
                                                    _this.videoElem.volume = e;
                                                    _this.videoElem.muted = false;
                                                }
                                            } })),
                                    React.createElement("img", { className: "opacity-control", onClick: function (e) {
                                            if (_this.videoElem)
                                                _this.videoElem.muted = !_this.state.muted;
                                            _this.setState({ muted: !_this.state.muted });
                                        }, src: (!_this.state.muted && _this.state.volume > 0) ? (_this.state.volume > 0.5 ? VOLUME_2_SVG : VOLUME_1_SVG) : VOLUME_0_SVG, height: 23 })))),
                        React.createElement("div", { className: "right-container", onClick: function () {
                                PlaybackManager.getInstance().stop();
                            } },
                            React.createElement("div", { className: "col close" },
                                React.createElement("img", { src: PLAYER_CLOSE_SVG, alt: "close" })))));
            }
        });
    };
    return Player;
}(React.Component));
var PlayerProgress = /** @class */ (function (_super) {
    __extends(PlayerProgress, _super);
    function PlayerProgress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onResize = _this.onResize.bind(_this);
        return _this;
    }
    PlayerProgress.prototype.componentDidMount = function () {
        var _this = this;
        PlaybackManager.getInstance().addPlaybackProgressStateListener(function (state) {
            _this.setState({ progressState: state });
        });
        PlaybackManager.getInstance().addPlaybackStateListener(function (state) {
            if (state.media && state.media.sound && state.media.sound.wave) {
                if (_this.state.coloredWave != state.media.sound.wave.red || _this.state.grayWave != state.media.sound.wave.gray) {
                    _this.setState({ grayWave: state.media.sound.wave.gray, coloredWave: state.media.sound.wave.red, lightWave: state.media.sound.wave.light });
                }
            }
        });
        document.addEventListener('resize', this.onResize);
    };
    PlayerProgress.prototype.componentWillUnmount = function () {
        document.removeEventListener('resize', this.onResize);
    };
    PlayerProgress.prototype.onResize = function (e) {
        if (this.containerRef)
            this.setState({ progressContainerWidth: this.containerRef.clientWidth });
    };
    PlayerProgress.prototype.setContainerRef = function (ref) {
        this.containerRef = ref;
        var cssOffset = 40 * 2 /* left duration and right duration */ + 8 * 2 /* left margin of wave and right duration */ + 15 * 2; /* col padding */
        if (this.containerRef && this.state.progressContainerWidth != (this.containerRef.clientWidth - cssOffset))
            this.setState({ progressContainerWidth: this.containerRef.clientWidth - cssOffset });
    };
    PlayerProgress.formatProgress = function (seconds) {
        if (!seconds) {
            return undefined;
        }
        return moment.utc(moment.duration(seconds, "s").asMilliseconds()).format("mm:ss");
    };
    PlayerProgress.progressInPercent = function (seconds, duration) {
        if (!seconds || !duration) {
            return 0;
        }
        return (100 / duration) * seconds;
    };
    PlayerProgress.prototype.render = function () {
        var _this = this;
        var coloredStyle = {
            width: (this.state.progressContainerWidth || 0) + 'px',
            backgroundImage: (this.state.coloredWave ? "url('" + this.state.coloredWave + "')" : '')
        };
        return React.createElement(UserContextConsumer, null, function (user) {
            var wave = _this.state.grayWave;
            if (user.theme == 'white') {
                wave = _this.state.lightWave;
            }
            return React.createElement("div", { className: 'optimize-contrast ' + (_this.props.className || ''), ref: function (ref) { return _this.setContainerRef(ref); } },
                React.createElement("div", { className: "progress-time my-auto" }, PlayerProgress.formatProgress(PlaybackManager.getInstance().getProgress()) || '00:00'),
                React.createElement("div", { className: "wave", onClick: function (e) {
                        if (PlaybackManager.getInstance().getDuration()) {
                            var percent = (100 / e.currentTarget.clientWidth) * e.nativeEvent.offsetX;
                            var targetDuration = PlaybackManager.getInstance().getDuration() * (percent / 100);
                            PlaybackManager.getInstance().seek(targetDuration);
                        }
                    }, style: { backgroundImage: (wave ? "url('" + wave + "')" : ''), position: 'relative' } },
                    React.createElement("div", { className: "colored-wave", style: {
                            width: PlayerProgress.progressInPercent(PlaybackManager.getInstance().getProgress(), PlaybackManager.getInstance().getDuration()) + "%"
                        } },
                        React.createElement("div", { className: "colored-wave-inner", style: coloredStyle }))),
                React.createElement("div", { className: "duration-time my-auto" }, PlayerProgress.formatProgress(PlaybackManager.getInstance().getDuration()) || '00:00'));
        });
    };
    return PlayerProgress;
}(React.PureComponent));
export { PlayerProgress };
export default Player;
//# sourceMappingURL=Player.js.map